export const LABEL_TEXT = "Campaign/Delivery name";
export const TOOLTIP_TEXT = `The campaign or delivery name allows Ingka DAM to collect assets to make them findable
and reusable for our consumers. If the assets are created locally by a market or a local 
external agency the delivery and sub delivery name will be set automatically. For bigger 
deliveries the name is set by the project leader in alignment with Market support and communicated to the administrators in Ingka DAM in advance so that we can add it to our metadata.
Example: Complete Sleep, Local production, Global Marketing Campaign and IKEA Food.`;
